import { css } from "../../../styled-system/css";

export const styles = {
  wrapper: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile3",
      backgroundColor: "white",
      height: "100%",
      paddingInline: "baseUnit.mobile4",
      desktop: {
        paddingInline: 0,
      },
    }),

  header: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
    }),

  headerTop: () =>
    css({
      display: "flex",
      gap: "baseUnit.mobile2",
      alignItems: "flex-start",
    }),

  headline: () =>
    css({
      fontSize: "heading.H2.mobile",
      fontWeight: 800,
      lineHeight: "heading.H2.mobile",
      letterSpacing: "heading.H2.mobile",
      color: "midnight",
      margin: 0,
      flex: 1,
      desktop: {
        fontSize: "heading.H2.desktop",
        lineHeight: "heading.H2.desktop",
        letterSpacing: "heading.H2.desktop",
      },
    }),

  subtitle: () =>
    css({
      fontSize: "body.mouse",
      fontWeight: 400,
      lineHeight: "body.mouse",
      letterSpacing: "body.mouse",
      color: "headlineGrey",
      margin: 0,
      desktop: {
        fontSize: "body.horse",
        lineHeight: "body.horse",
        letterSpacing: "body.horse",
      },
    }),

  mascotWrapper: () =>
    css({
      display: "flex",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      width: "baseUnit.mobile8",
      height: "baseUnit.mobile8",
      borderRadius: "50%",
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "midnight",
      overflow: "hidden",
    }),

  mascotImage: () =>
    css({
      width: "100%",
      height: "auto",
      objectFit: "cover",
    }),

  cardList: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile2",
    }),

  footer: () =>
    css({
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      desktop: {
        alignItems: "flex-end",
      },
    }),

  errorMessage: () =>
    css({
      fontSize: "body.shrimp",
      fontWeight: 400,
      lineHeight: "body.shrimp",
      letterSpacing: "body.shrimp",
      color: "red",
      margin: 0,
      marginBottom: "baseUnit.mobile1",
    }),
};
